import { render, staticRenderFns } from "./invoiceHelp.vue?vue&type=template&id=3538c4b0&scoped=true&"
import script from "./invoiceHelp.vue?vue&type=script&lang=js&"
export * from "./invoiceHelp.vue?vue&type=script&lang=js&"
import style0 from "./invoiceHelp.vue?vue&type=style&index=0&id=3538c4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538c4b0",
  null
  
)

export default component.exports